<div class="container-fluid wrapper-page">
  <div align="center">
    <h4 class="mt-2 mb-2">EDIT PROFILE - FRONT DESK</h4>
  </div>
  <div class="page-head">
    <h5><a href="javascript:void(0)"><i class="fa fa-arrow-circle-left" (click)="getback()"> BACK
        </i></a>
    </h5>
  </div>
  <form #editFdeskForm="ngForm" enctype="multipart/form-data">
    <div class="row">
      <div class="col-lg-12">
        <div class="card m-b 30">
          <div class="card-body">
            <ul class="tablist">
              <li role="tab"><a class="nav-link" [ngClass]="{'active':editFdeskCurrentTab == 'personalInformation'}"
                  href="javascript:void(0)" role="tab"><span class="number">1.</span>Personal Information</a></li>

            </ul>
            <!----========   PERSONAL INFORMATION =========================  -->
            <ng-container *ngIf="editFdeskCurrentTab=='personalInformation'">

              <section class="mt-3 ml-2 align-items-center">
                <div class="form-group row mb30">
                  <div class="col-md-1">
                  </div>
                  <div class="col-md-10">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="avaitarImg">
                          <!-- <img src="assets/new-ui/images/users/avatar.jpg" style="height: 180px; border-radius: 10px;"
                            class=""> -->
                          <label class="hoverable" for="fileInput">
                            <!-- <img [src]="user.ppurl">
                            <div class="hover-text">Edit</div>
                            <div class="background"></div> -->

                            <img *ngIf="avatartimg != 'img_avatar.png'" [src]="user && user?.ppurl ? user?.ppurl : ''">
                            <div class="hover-text"><i class="fa fa-camera" style="font-size: 32px;"></i></div>
                            <div class="background"></div>


                            <div class="profileImage" *ngIf="avatartimg == 'img_avatar.png'">
                              <!-- <avatar text={{fdeskname}}></avatar> -->
                              <img [src]="user && user?.ppurl ? user?.ppurl : ''">
                              <div class="hover-text"><i class="fa fa-camera" style="font-size: 32px;"></i></div>
                              <div class="background"></div>
                            </div>

                          </label>
                          <br>
                          <input id="fileInput" type='file' accept=".png, .jpg, .jpeg" (change)="fileSelected($event)">
                        </div>
                      </div>
                      <div class="col-md-8">
                        <h5 class="innerheading">Personal Information</h5>
                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label>First Name</label>
                          </div>
                          <div class="col-6 col-md-8">
                            {{user.first_name}}
                          </div>
                        </div>
                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label>Last Name</label>
                          </div>
                          <div class="col-6 col-md-8">
                            {{user.last_name}}
                          </div>
                        </div>
                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label>Date of Birth</label>
                          </div>
                          <div class="col-6 col-md-8">
                            {{user.dob | date:'dd-MM-yyyy'}}
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="col-md-1">
                  </div>
                </div>
                <br>
                <div class="form-group row">
                  <div class="col-md-1">
                  </div>
                  <div class="col-md-10">
                    <div class="row mb10">

                      <div class="col-md-6">
                        <h5 class="innerheading">CONTACT DETAILS</h5>
                        <div class="row">
                          <div class="col-6 col-md-4">
                            <label>Address</label>
                          </div>
                          <div class="col-6 col-md-8">
                            <p>
                              <editable (update)="updateField('address_1')">
                                <ng-template viewMode>{{user.address_1 || "Enter address"}}
                                </ng-template>
                                <ng-template editMode>
                                  <input class="form-control" [formControl]="getControl('address_1')" focusable>
                                </ng-template>
                              </editable>
                              <span *ngIf="f.address_1.errors" class="invalid-feedback">This is
                                required</span>
                            </p>
                            <p>
                              <editable (update)="updateField('address_2')">
                                <ng-template viewMode>{{user.address_2 || "Enter city"}}
                                </ng-template>
                                <ng-template editMode>
                                  <input class="form-control" [formControl]="getControl('address_2')" focusable>
                                </ng-template>
                              </editable>
                              <span *ngIf="f.address_2.errors" class="invalid-feedback">This is
                                required</span>
                            </p>
                          </div>
                        </div>
                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label>Contact</label>
                          </div>
                          <div class="col-6 col-md-8">
                            <editable (update)="updateField('contact_no')">
                              <ng-template viewMode>{{user.contact_no || "Contact Number"}}
                              </ng-template>
                              <ng-template editMode>
                                <input class="form-control" [formControl]="getControl('contact_no')" focusable
                                  maxlength="12" minlength="10">
                                <div *ngIf="getControl('contact_no').errors" class="invalid-feedback">Invalid
                                  Contact Number.</div>
                              </ng-template>
                            </editable>
                            <span *ngIf="f.contact_no.errors && f.contact_no.errors.required"
                              class="invalid-feedback">This is
                              required</span>
                          </div>
                        </div>
                        <div class="row" mb10>
                          <div class="col-6 col-md-4">
                            <label>Email</label>
                          </div>
                          <div class="col-6 col-md-8">
                            {{user.email_id}}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 ">
                        <h5 class="innerheading">ADDITIONAL INFORMATION</h5>
                        <div class="row mb10 addinfo">
                          <div class="col-12 col-md-12">
                            <editable (update)="updateField('additional_info')">
                              <ng-template viewMode>{{user.additional_info || 'Enter additional Information'}}
                              </ng-template>
                              <ng-template editMode>
                                <input class="form-control" [formControl]="getControl('additional_info')" focusable>
                              </ng-template>
                            </editable>
                            <div *ngIf="f.additional_info.errors" class="invalid-feedback">This is
                              required</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-1">
                  </div>
                </div>


              </section>

            </ng-container>

          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-10"></div>
      <div class="col-2">
        <button type="button" (click)="saveFrontDesk()" [disabled]="forms['personalInformation'].invalid"
          class="btn btn-primary btn-patient pull-right">Save</button>
      </div>
    </div>
  </form>
</div>